import React, { useEffect, useContext } from 'react';
import ComingSoon from './common/ComingSoon';
import Context from '../context/Context';

const Storage = () => {
  const { setPageTitle } = useContext(Context);

  useEffect(() => {
    setPageTitle('Storage');
  }, [setPageTitle]);

  return (
    <ComingSoon />
  );
};

export default Storage;
